export enum ExtraIngredientUpsellStrategy {
  NONE = 'None',
  FIRST_PRICED = 'First Priced',
  MARKED_UPSELL = 'Marked Upsell',
}
